import styled from 'styled-components';

export const BannerWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;

	width: 360px;
	margin-top: 8px;

	img {
		width: 100%;
		height: auto;
	}

	@media (min-width: 600px) {
		width: 690px;
	}
`;
